import { switchMap } from 'rxjs/operators';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../../../services/common/auth.service';
import { AlertService } from '../../../services/common/alert.service';
import { VendorService } from '../../../services/accounting/vendor.service';

declare var window: any;

@Component({
  selector: 'app-vendor-show',
  templateUrl: './vendor-show.component.html',
  styleUrls: ['./vendor-show.component.css'],
})
export class VendorShowComponent implements OnInit {
  closeResult: string;

  vendorLoading: boolean = true;

  vendor: any = {};

  to_be_paids: Array<any> = [];

  to_be_paid_search_params: any = {
    C: true,
    P: true,
    O: true,
    V: true,
    charge: true,
    payment: true,
    page: 1,
    per_page: 20,
  };

  to_be_paids_count: number = 0;

  selectedMatterId: number | undefined;
  selectedMatterName: string | undefined;

  matterToBeRemoved: any;

  showPayments: boolean = false;

  constructor(private authService: AuthService, private alertService: AlertService, private vendorService: VendorService, private route: ActivatedRoute, private router: Router, private modalService: NgbModal) {
    this.authService.fetchUserGroups().then((response_json) => {
      let groups = response_json.groups;
      if (groups.indexOf('personnel') > -1 || groups.indexOf('admin') > -1 || groups.indexOf('management') > -1 || groups.indexOf('owner') > -1)
        this.route.params.pipe(switchMap((params: Params) => this.vendorService.getVendor(Number(params['id'])))).subscribe((response_json) => {
          this.vendor = response_json.vendor;
          this.vendorLoading = false;
          this.to_be_paids = this.vendor.to_be_paids;
          this.to_be_paid_search_params.per_page = response_json.per_page;
          this.to_be_paid_search_params.statuses = response_json.statuses;
          this.to_be_paid_search_params.bill_types = response_json.bill_types;
          this.to_be_paids_count = response_json.vendor.to_be_paids_count;
          this.togglePaymentsShow(false);
        });
      else this.router.navigate(['/']);
    });
  }

  ngOnInit() {}

  goBack() {
    window.history.back();
  }

  loadToBePaids() {
    this.vendorService.getToBePaids(this.vendor.id, this.to_be_paid_search_params).then((response_json) => {
      this.to_be_paids = response_json.to_be_paids;
      this.to_be_paids_count = response_json.to_be_paids_count;
      this.togglePaymentsShow(false);
    });
  }

  toBePaidPageChanged(event: any) {
    this.to_be_paid_search_params.page = Number(event.page);
    this.loadToBePaids();
  }

  togglePaymentsShow(toggle: boolean = true) {
    if (toggle) this.showPayments = !this.showPayments;
    for (let to_be_paid of this.to_be_paids) to_be_paid.show_payments = this.showPayments;
  }

  statusName(status: string): string {
    switch (status) {
      case 'outstanding':
        return 'warning';
      case 'void':
        return 'dark';
      case 'paid':
        return 'success';
      case 'contested':
        return 'danger';
      default:
        return 'light';
    }
  }

  deleteVendorModal(deleteModal: TemplateRef<any>) {
    this.modalService.open(deleteModal).result.then(
      (result) => {
        if (result == 'delete') this.deleteVendor();
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  deleteVendor() {
    let scope: VendorShowComponent = this;
    this.alertService.alert_status_info_overlay('Deleting vendor <i class="fas fa-spinner fa-pulse fa-fw"></i>');
    this.vendorService
      .deleteVendor(this.vendor.id)
      .then((response_json) => {
        this.alertService.alert_status_clear_overlay();
        if (response_json.success) {
          this.alertService.alert_status_success(response_json.text || 'Vendor deleted successfully');
          window.history.back();
        } else this.alertService.alert_status_danger(response_json.text || 'Error deleting vendor');
      })
      .catch(() => {
        scope.alertService.alert_status_clear_overlay();
        scope.alertService.alert_status_danger('Error deleting vendor');
      });
  }

  onMatterSelect(event: any) {
    this.selectedMatterId = event.id;
    this.selectedMatterName = event.label;
  }

  cancelMatterAdd() {
    this.selectedMatterId = undefined;
    this.selectedMatterName = undefined;
  }

  addMatter() {
    if (this.selectedMatterId) {
      this.alertService.alert_status_info_overlay('Adding vendor to matter <i class="fas fa-spinner fa-fw fa-pulse"></i>');
      let scope = this;
      this.vendorService
        .addMatter(this.vendor.id, this.selectedMatterId)
        .then((response_json) => {
          if (response_json.success) {
            scope.alertService.alert_status_clear_overlay();
            this.alertService.alert_status_success('Vendor added to matter');
            this.vendor.matters = response_json.matters;
            this.selectedMatterId = undefined;
            this.selectedMatterName = undefined;
          } else {
            scope.alertService.alert_status_clear_overlay();
            this.alertService.alert_status_danger(response_json.text || 'Error adding vendor to matter');
          }
        })
        .catch(function () {
          scope.alertService.alert_status_clear_overlay();
          scope.alertService.alert_status_danger('Error adding vendor to matter');
        });
    } else this.alertService.alert_status_danger('Matter not selected, please select and try adding it again');
  }

  removeMatter(matter_id: number) {
    this.alertService.alert_status_info_overlay('Removing vendor from matter <i class="fas fa-spinner fa-fw fa-pulse"></i>');
    let scope = this;
    this.vendorService
      .removeMatter(this.vendor.id, matter_id)
      .then((response_json) => {
        if (response_json.success) {
          scope.alertService.alert_status_clear_overlay();
          this.alertService.alert_status_warning('Vendor removed from matter', '', true);
          this.vendor.matters = response_json.matters;
        } else {
          scope.alertService.alert_status_clear_overlay();
          this.alertService.alert_status_danger(response_json.text || 'Error adding vendor to matter');
        }
      })
      .catch(function () {
        scope.alertService.alert_status_clear_overlay();
        scope.alertService.alert_status_danger('Error adding vendor to matter');
      });
  }

  removeMatterModal(removeModal: TemplateRef<any>, matter: any) {
    this.matterToBeRemoved = matter;
    this.modalService.open(removeModal).result.then(
      (result) => {
        this.matterToBeRemoved = null;
        if (result == 'remove') this.removeMatter(matter.id);
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.matterToBeRemoved = null;
        //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  matterFilterChange(matter: any) {
    this.to_be_paid_search_params[`${matter.id}`] = matter.show_to_be_paids;
    this.loadToBePaids();
  }
}
